<div  class="item" *ngIf="bunch.isActive" >
        <a [id]="bunch.bunch.id" [style]=" displayLevel()" (click)="selected($event)" >{{bunch.bunch.name}}</a> 
        <button *ngIf="bunch.listChild.length > 0" type="button" [id]="bunch.bunch.id" class="icons-select-item" (click)="clickChildItem()" [style]="iconStyle"></button>
</div>

